module.exports = __webpack_public_path__ + "img/highroller_900.1c261631.png";